

/*
	Source: htdocs/wim/js/core/src/WeatherData.js
*/
(function($, wimbledonCore) {
/**
     *  Poller Class
     *      Used for setting up repeating AJAX loads. Supports
     *      a variety of options ranging from simple to complex.
     */
    function WeatherData() {
        var id = 'WeatherData';
        var logger = new eventsCore.util.Logger(id);
        var api = {};
        var loaders = {};
        var dayUnits;
        var hourUnits;
        var curUnits;
        var tempSuffix;

        var degStd = '\u00B0';
        var degUnder = '\u00ba';

        var units = {};
        units.h = {
            'speed': 'MPH',
            'rain': 'cm',
            'temp': degStd + 'C',
            'tempSuf': '_c'
        };
        units.e = {
            'speed': 'MPH',
            'rain': 'in',
            'temp': degStd + 'F',
            'tempSuf': '_f'
        };

        logger.info('constructor - path:%o configId:%o');

        var onCompositeLoaded = function(data) {
            logger.info('onCompositeLoaded data:%o', data);

            // ********** populate current data
            curUnits = data.current.units;
            tempSuffix = units[curUnits]['tempSuf'];

            // var dataStr = '';
            // dataStr += '<b>Observation:</b> ' + data.current.phrase_32char;
            // dataStr += '<br> <b>Current Temp:</b> ' + data.current.temp + units[curUnits].temp;
            // dataStr += '<br> <b>Wind:</b> ' + data.current.wind_speed + units[curUnits].speed;
            // dataStr += '<br> <b>Feels Like:</b> ' + data.current.feels_like + units[curUnits].temp;
            // dataStr += '<br> <b>Precip 1Hr:</b> ' + data.current.precip_1hour;
            // $('#current').html(dataStr);
            $('.weatherCurrentTemp').html(data.current['temp' + tempSuffix] + units[curUnits].temp);
            $('#currentObs').html('<b>Observation: </b>' + data.current.phrase_32char);
            $('#currentWind').html('<b>Wind: </b>' + data.current.wind_speed + units[curUnits].speed + ' <div class="img"><img src="/images/weather/wc_wind_green/wind' + data.current.wind_dir + '.png"/></div>');
            $('#currentFeels').html('<b>Feels Like: </b>' + data.current['feels_like' + tempSuffix] + units[curUnits].temp);
            $('#currentPrecip').html('<b>Precip 1Hr: </b>' + data.current.precip_1hour + units[curUnits].rain);

            // *********** populate daily data
            dayUnits = data.day.units;
            var forecastNarr = '';
            var dayobj;
            var startDay = 0;
            var endDay = 5;
            var dayLab = 1;

            if (!data.day.days[0].day_narrative_f) {
                startDay = 1;
                endDay = 6;
            }

            for (var i = startDay; i < Math.min(data.day.days.length, endDay); i++) {
                dayobj = data.day.days[i];
                logger.info('onCompositeLoaded - daily - i:%o day:%o icon:%o', i, dayobj, dayobj.icon_code);
                forecastNarr += '<h4>' + dayobj.dow + ':</h4><p>' + replaceDegree(dayobj['day_narrative' + tempSuffix]) + '</p>';

                $('#tableDay' + dayLab).html(dayobj.dow);
                $('#tableDayHigh' + dayLab).html(dayobj['max_temp' + tempSuffix] + units[dayUnits].temp);
                $('#tableDayLow' + dayLab).html(dayobj['min_temp' + tempSuffix] + units[dayUnits].temp);
                $('#tableDayImage' + dayLab).html('<img src="/images/weather/wc_png/' + dayobj.icon_code + '.png" alt="' + dayobj.phrase_32char + '" width="45" height="45"/>');

                dayLab++;
            }
                
            $('.forecastNarratives').html(forecastNarr);

            //*********** populate hourly data
            var hourobj;

            var hourUnits = data.hour.units;

            for (var i = 1; i < Math.min(data.hour.hours.length,8); i++) {
                hourobj = data.hour.hours[i];
                //logger.info('onHourlyLoaded i:%o', data.hour);
                logger.info('onCompositeLoaded - hourly - i:%o hour:%o time:%o', i, hourobj, hourobj.time);
                
                $('#tableHour' + i).html(hourobj.time);
                $('#tableHourHigh' + i).html(hourobj['temp' + tempSuffix] + units[hourUnits].temp);
                $('#tableHourSpeed' + i).html(hourobj.wind_speed + units[hourUnits].speed);
                $('#tableHourImage' + i).html('<img src="/images/weather/wc_png/' + hourobj.icon_code + '.png" alt="' + hourobj.phrase_32char + '" width="45" height="45"/>');
                $('#tableHourWind' + i).html('<img src="/images/weather/wc_wind/wind' + hourobj.wdir + '.png" alt="Wind: ' + hourobj.wdir + '" />');
                
                //account for calm and variable wind dir
            }
        };

        var onDayLoaded = function(data) {
            logger.info('onDayLoaded data:%o', data);

            dayUnits = data.metadata.units;

            //logger.info('onDayLoaded narrative:%o', data.forecasts[0].narrative);
            if (data.forecasts[0].day) {
                $('#headline').html(data.forecasts[0].day.narrative);
            }
            else if(data.forecasts[0].night) {
                $('#headline').html(data.forecasts[0].night.narrative);
            }

            var forecastNarr = '';
            var day;
            for (var i = 1; i < Math.min(data.forecasts.length,6); i++) {
                day = data.forecasts[i];
                logger.info('onDayLoaded day:%o icon:%o', day, day.day.icon_code);
                forecastNarr += '<h4 style="margin-bottom: 5px;">' + day.dow + ':</h4><p style="margin-top: 0px;">' + day.day.narrative + '</p>';

                $('#tableDay' + i).html(day.dow);
                $('#tableDayHigh' + i).html(day.max_temp + units[dayUnits].temp);
                $('#tableDayLow' + i).html(day.min_temp + units[dayUnits].temp);
                $('#tableDayImage' + i).html('<img src="/images/weather/wc_png/' + day.day.icon_code + '.png" alt="' + day.day.phrase_32char + '" width="45" height="45"/>');
            }
                
            $('#forecastNarratives').html(forecastNarr);
        };

        var onHourlyLoaded = function(data) {
            logger.info('onHourlyLoaded data:%o', data);
            var hour;
            var time;

            hourUnits = data.metadata.units;

            for (var i = 0; i < Math.min(data.forecasts.length,6); i++) {
                hour = data.forecasts[i];
                time = new Date(hour.fcst_valid * 1000);
                logger.info('onHourlyLoaded hour:%o time:%o', hour, time + ' ' + time.getUTCHours());
                
                $('#tableHour' + i).html(time.getUTCHours() + ':00');
                $('#tableHourHigh' + i).html(hour.temp + units[hourUnits].temp);
                $('#tableHourSpeed' + i).html(hour.wspd + units[hourUnits].speed);
                $('#tableHourImage' + i).html('<img src="/images/weather/wc_png/' + hour.icon_code + '.png" alt="' + hour.phrase_32char + '" width="45" height="45"/>');
                $('#tableHourWind' + i).html('<img src="/images/weather/wc_wind/wind' + hour.wdir_cardinal + '.png" alt="Wind: ' + hour.wdir_cardinal + '" />');
                
                //account for calm and variable wind dir
            }
        };

        var onCurrentLoaded = function(data) {
            logger.info('onCurrentLoaded data:%o', data);
            curUnits = data.metadata.units;

            var dataStr = '';
            dataStr += '<b>Observation:</b> ' + data.observation.phrase_32char;
            dataStr += '<br> <b>Current Temp:</b> ' + data.observation.uk_hybrid.temp + units['h'].temp;
            dataStr += '<br> <b>Wind:</b> ' + data.observation.uk_hybrid.wspd + units['h'].speed;
            dataStr += '<br> <b>Feels Like:</b> ' + data.observation.uk_hybrid.feels_like + units['h'].temp;
            dataStr += '<br> <b>Precip 1Hr:</b> ' + data.observation.uk_hybrid.precip_1hour;

            $('#current').html(dataStr);
        };

        var dataLoadHandler = function(_data) {
            if (dataString !== JSON.stringify(_data)){
                data = _data;
                dataString = JSON.stringify(data);

                logger.info('dataLoadHandler - data:%o', data);
            }
        };

        var replaceDegree = function(str) {
            var temp = str.split('º');
            temp = temp.join(degStd);
            return temp;
        }

        api.startLoading = function(_feeds, _interval) {
            var feed = {};

            _.each(_feeds, function(key, value) {
                logger.info('startLoading - key:%o value:%o %o', key, value);
                feed = {};

                if (key.id === 'composite') {
                    feed[key.url] = onCompositeLoaded;
                }
                else if (key.id === 'tenDay') {
                    feed[key.url] = onDayLoaded;
                }
                else if (key.id === 'hourly'){
                    feed[key.url] = onHourlyLoaded;
                }
                else if (key.id === 'current'){
                    feed[key.url] = onCurrentLoaded;
                }

                loaders[key.id] = key;
                loaders[key.id]['loader'] = eventsCore.Poller(key.id);
                loaders[key.id]['loader'].add(feed, (key.interval * 1000))

                /*
                if (value === 'tenDay') {
                    feeds[key] = onDayLoaded;
                }
                else if (value === 'hourly'){
                    feeds[key] = onHourlyLoaded;
                }
                */
            });

            //dataLoader.add(feeds, (_interval * 1000));
        };

        return api;
    };

    wimbledonCore.weatherData = new WeatherData();

}(jQuery, window.wimbledonCore));